<!-- start first-play-slide -->
<section
  class="mb-6 mb-md-0 section-outset-y position-relative play-word-container scroll-trigger"
  id="play-slide-word"
  *ngIf="block.playSlideItems?.length"
>
  <div class="container">
    <div class="row play-word">
      <div class="play-word__letters col-5 col-sm-12">
        <div class="play-slide col-12 col-sm-3" *ngFor="let item of block.playSlideItems; let i = index">
          <div class="play-slide__letter-container d-flex align-items-center flex-column">
            <h2 class="play-slide__letter text-primary-gradient mb-0 anim-fade-up delay--1">{{ item.character.toUpperCase() }}</h2>
            <span class="h3 d-none d-sm-block mb-0 play-word__word anim-fade-up delay--2">{{ item.word }}</span>
          </div>
        </div>
      </div>
      <div class="play-word__text col-7 col-sm-12 mt-sm-6 ms-sm-auto text-max-width-md">
        <!--<fstr-icon class="play-word__icon" anchor="icon-doodle-arrow-right"></fstr-icon>-->
        <app-text-shape
          [shapeColor]="'-'"
          [autoplay]="false"
          class="play-word__icon"
          type="standalone"
          [shape]="'arrow-07'"
          [startAnimation]="activeScrollTrigger.includes('play-slide-word')"
        ></app-text-shape>

        <p class="fs-6" [innerHTML]="'play-eerste-slide-tekst' | fromDictionary | highlight : 'underline'"></p>
      </div>
      <div class="pull-s background-dots-play-slide"></div>
    </div>
  </div>
</section>

<div class="play-word__scroll-indicator">
  <app-scroll-indicator [text]="'eerste-play-slide-scroll-indicator-text' | fromDictionary"></app-scroll-indicator>
</div>

<!-- end first-play-slide -->

<article class="block-play-slide">
  <div class="play-slide" *ngFor="let item of block.playSlideItems; let i = index" [ngClass]="'theme--' + sectionTheme(i)">
    <div class="container section-inset-y scroll-trigger" [id]="id(item)">
      <!-- slides -->
      <div class="row">
        <div class="col-md-5 play-slide__letter-container">
          <span class="play-slide__letter text-primary-gradient position-relative z-index-2 splitting splitting--word-in delay--1">
            <div class="word">
              <span class="char">{{ item.character.toUpperCase() }}</span>
            </div>
          </span>

          <div class="pull-s play-slide__letter__figure z-index-2" *ngIf="item.image?.url">
            <fstr-image [image]="item.image" [alt]="item.image.alt || item.title" [imageSizes]="[300, 500, 800, 900]"></fstr-image>
          </div>
          <div class="pull-s background-dots"></div>
        </div>

        <div class="col-md-7 position-relative z-index-2">
          <p class="fs-6 anim-fade-up delay--1" [innerHTML]="item.text | highlight : 'underline'"></p>

          <div class="play-slide__title mt-lg-5">
            <!--<fstr-icon
              *ngIf="i % 2 === 0 ? 'icon-doodle-arrow-bow-right' : 'icon-doodle-arrow-corner-right' as icon"
              class="play-slide__title__icon"
              [ngClass]="'aspect-ratio-' + icon"
              [anchor]="icon"
            ></fstr-icon>-->

            <!--@glenn-->
            <app-text-shape
              [autoplay]="false"
              class="play-slide__title__icon"
              type="standalone"
              [shapeColor]="'-'"
              [shape]="i % 2 === 0 ? 'arrow-11' : 'arrow-08'"
              [startAnimation]="activeScrollTrigger.includes(id(item))"
            ></app-text-shape>

            <h2 class="play-slide__title__text mb-0 splitting splitting--word-in" splitting>
              <span class="text-uppercase" [innerHTML]="item.title | highlight : 'text-primary-gradient'"></span>
              <fstr-icon class="play-slide__title__figure" *ngIf="item.icon" [anchor]="item.icon"></fstr-icon>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
